<template>
<div>
     <van-nav-bar
  title="邀请记录"
  left-arrow
  @click-left="$router.go(-1)"
/>
    <van-empty description="暂无数据" />
</div> 
</template>


<script>
export default {
    data(){
        return{
            inviteList:[], // 邀请列表
            page:1,
            total:10,
        }
    },
    computed:{
    },
    created(){
        this.Post({
        }, "/main/invite", res => {
            if (res.states == 1) {
                this.inviteList = res.data.list
                this.total=res.data.total;
                this.page=res.data.page;
            }else{
                this.Toast.fail(res.msg);
            }
        });
    },
}
</script>

<style lang="less" rel="stylesheet/less" scoped>

</style>


// WEBPACK FOOTER //
// src/pages/mine/inviteRecord.vue